import { UploadState } from '@vp/manager/gallery/data/upload/state/UploadState';

export class FailedState extends UploadState {}
